module.exports = __webpack_public_path__ + "img/cashier03.1ec97cb0.png";